import flat from "flat";
import localeUS from "./en-US.json";
import localeES from "./es.json";
import localeCN from "./zh-CN.json";
import localeJA from "./ja.json";
import localeSV from "./sv.json";

type LanguageTag = "default" | "en-US" | "zh-CN" | "es" | "ja" | "sv";
const defaultLang = flat(localeUS);
const LANGUAGES = [
  {
    key: "en-US",
    name: "English",
  },
  {
    key: "es",
    name: "Español"
  },
  {
    key: "zh-CN",
    name: "中文"
  },
  {
    key: "ja",
    name: "日本語"
  },
  {
    key: "sv",
    name: "Svenska"
  }
];

const LOCALES_DATA: { [name in LanguageTag]: any } = {
  default: defaultLang,
  "en-US": defaultLang,
  "es": flat(localeES),
  "zh-CN": flat(localeCN),
  "ja": flat(localeJA),
  "sv": flat(localeSV),
};

export { LANGUAGES, LOCALES_DATA };
